export default __webpack_public_path__ + "static/banner-assinatura-f77bcc43e41c69e3e399e6bdf34daae2.jpg";